import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AppContextService } from '../services/app-context.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (typeof window === 'undefined') return next(req);

  // Não injeta headers de autenticação em APIs externas (evita CORS)
  const url = req.url.toLowerCase();
  const isInternalApi = url.includes('easyerp.one') || url.includes('easyerp.pro') || url.includes('atsone.com.br') || url.includes('localhost');
  if (!isInternalApi) return next(req);

  const appContext = inject(AppContextService);
  const raw = sessionStorage.getItem(appContext.tokenStorageKey);

  if (raw) {
    try {
      const token: string = JSON.parse(raw).token;
      if (token) {
        // Em uploads (FormData) NÃO setar Content-Type: o navegador precisa pôr
        // "multipart/form-data; boundary=…" sozinho, senão o servidor não acha o arquivo.
        const isFormData = req.body instanceof FormData;
        req = req.clone({
          setHeaders: isFormData
            ? { 'Authorization': token }
            : { 'Authorization': token, 'Content-Type': 'application/json', 'Accept': 'application/json' }
        });
      }
    } catch {}
  }
  return next(req);
};
